import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import styles from './ModalBase.module.scss';
const ModalBase = ({ children, onClose, modifier = '' }) => {
    return ReactDOM.createPortal(_jsx("div", Object.assign({ className: styles.modal, onClick: onClose, "data-testid": "modal-base" }, { children: _jsx("div", Object.assign({ className: `${styles.modal__content} ${modifier ? styles[modifier] : ''}`, onClick: (e) => e.stopPropagation() }, { children: children })) })), document.body);
};
export default ModalBase;
